import { Injectable } from '@angular/core';
import { Medidas } from 'src/app/common/models/Medidas';
import measures from 'src/assets/json/cards_measures.json';

@Injectable()
export class MeasuresService {

  Measures: any = measures;

  getTop(code: string) {

    if (!this.Measures) {
      return '0px';
    }

    var top = this.Measures.filter(x => x.code == "default")[0].medidas.miniature_top;

    if (this.Measures.filter(x => x.code == code).length > 0) {
      top = this.Measures.filter(x => x.code == code)[0].medidas.miniature_top;
    }

    return top;

  }

  getLeft(code: string) {

    if (!this.Measures) {
      return '0px';
    }

    var left = this.Measures.filter(x => x.code == "default")[0].medidas.miniature_left;

    if (this.Measures.filter(x => x.code == code).length > 0) {
      left = this.Measures.filter(x => x.code == code)[0].medidas.miniature_left;
    }

    return left;

  }

  getDeckTop(code: string) {

    if (!this.Measures) {
      return '0px';
    }

    if (this.Measures.filter(x => x.code == code).length > 0) {
      return this.Measures.filter(x => x.code == code)[0].medidas.deck_top;
    } else {
      return this.Measures.filter(x => x.code == "default")[0].medidas.deck_top;
    }
 
  }

  getDeckLeft(code: string) {

    if (!this.Measures) {
      return '0px';
    }

    if (this.Measures.filter(x => x.code == code).length > 0) {
      return this.Measures.filter(x => x.code == code)[0].medidas.deck_left;
    } else {
      return this.Measures.filter(x => x.code == "default")[0].medidas.deck_left;
    }
     
  }

  getMiniaureStyle(code: string) {

    if (!this.Measures) {
      let stylesd = {
        'width': '68px',
        'height': '102px',
        'margin-left': '-20px',
        'margin-top': '-6px'
      };

      return stylesd;
    }

    var miniature_left;
    var miniature_top;
    var miniature_height;
    var miniature_width;

    var default_measure = this.Measures.filter(x => x.code == "default")[0];
    var measure = this.Measures.filter(x => x.code == code)[0];

    if (measure != null) {

      if (measure.medidas.miniature_left != null) {
        miniature_left = measure.medidas.miniature_left;
      } else {
        miniature_left = default_measure.medidas.miniature_left;
      }

      if (measure.medidas.miniature_top != null) {
        miniature_top = measure.medidas.miniature_top;
      } else {
        miniature_top = default_measure.medidas.miniature_top;
      }

      if (measure.medidas.miniature_height != null) {
        miniature_height = measure.medidas.miniature_height;
      } else {
        miniature_height = default_measure.medidas.miniature_height;
      }

      if (measure.medidas.miniature_width != null) {
        miniature_width = measure.medidas.miniature_width;
      } else {
        miniature_width = default_measure.medidas.miniature_width;
      }

    } else {

      miniature_left = default_measure.medidas.miniature_left;
      miniature_top = default_measure.medidas.miniature_top;
      miniature_height = default_measure.medidas.miniature_height;
      miniature_width = default_measure.medidas.miniature_width;

    }

    let styles = {
      'width': miniature_width,
      'height': miniature_height,
      'margin-left': miniature_left,
      'margin-top': miniature_top
    };

    return styles;
 
  }

}
